var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[(_vm.btn.items)?_c('v-app-bar-menu-btn',{attrs:{"btn":_vm.btn}}):(_vm.btn.badge)?_c('v-app-bar-badge-btn',{attrs:{"btn":_vm.btn}}):(_vm.btn.tip)?_c('v-app-bar-tip-btn',{attrs:{"btn":_vm.btn}}):_c('v-app-btn',{attrs:{"btn":_vm.btn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }